export class InvalidTimeframe extends Error {
    constructor(timeframe) {
        super(`The supplied timeframe range of [${timeframe.start}, ${timeframe.end}) was invalid.`);
        this.timeframe = timeframe;
    }
}
